import JSONAPISerializer from '@ember-data/serializer/json-api';
import { dasherize } from '@ember/string';

export default class ApplicationSerializer extends JSONAPISerializer {
  modelNameFromPayloadKey(key) {
    return dasherize(key);
  }

  keyForAttribute(key) {
    return key;
  }
}
